import JSZip from 'jszip';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import symbolApi from '../../APIs/symbols';
import {
  Button,
  Checkbox,
  Divider,
  NavigateBack,
  Typography,
} from '../../designComponents';
import { RootState } from '../../store/selectors';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import theme from '../../theme';
import { requestAPI } from '../../utils';
import { ViewJobContainerStyled } from '../BrowseJobs/BrowseJobDetails/style';
// import { DownloadSymbolContainerStyled } from './style';

type Props = {};

const DownloadSymbols = (_props: Props) => {
  const [selectedImagesMap, setSelectedImagesMap] = useState<{
    [key: string]: string[];
  }>({});

  const symbolsData = useSelector((state: RootState) => state.symbols.data);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await requestAPI(symbolApi.getSymbols({}));
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  const handleCheckboxChange = (symbolId: string, imageId: string) => {
    setSelectedImagesMap((prevSelectedImagesMap) => {
      const selectedImages = prevSelectedImagesMap[symbolId] || [];
      if (selectedImages.includes(imageId)) {
        return {
          ...prevSelectedImagesMap,
          [symbolId]: selectedImages.filter((id) => id !== imageId),
        };
      }
      return {
        ...prevSelectedImagesMap,
        [symbolId]: [...selectedImages, imageId],
      };
    });
  };
  const handleDownload = (symbolId: string) => {
    const zip = new JSZip();

    const selectedImages = selectedImagesMap[symbolId] || [];
    const selectedSymbol = symbolsData.find(
      (symbol) => symbol._id === symbolId,
    );

    if (selectedSymbol) {
      selectedImages.forEach(async (imageId) => {
        const selectedImage = selectedSymbol.uploadSymbol.find(
          (upload: any) => upload._id === imageId,
        );

        if (selectedImage) {
          try {
            const encodedUrl = encodeURIComponent(selectedImage.url);
            const response = await fetch(encodedUrl);
            const blob = await response.blob();

            zip.file(`${selectedImage._id}.png`, blob, { binary: true });
          } catch (error) {
            console.error('Error downloading image:', error);
          }
        }
      });
    }

    zip.generateAsync({ type: 'blob' }).then((content) => {
      const downloadUrl = URL.createObjectURL(content);

      const downloadLink = document.createElement('a');
      downloadLink.href = downloadUrl;
      downloadLink.setAttribute('download', `${symbolId}.zip`);
      document.body.appendChild(downloadLink);
      downloadLink.click();

      URL.revokeObjectURL(downloadUrl);
    });
  };

  // const handleDownload = (symbolId: string) => {
  //   const zip = JSZip();

  //   const selectedImages = selectedImagesMap[symbolId] || [];
  //   const selectedSymbol = symbolsData.find(
  //     (symbol) => symbol._id === symbolId
  //   );

  //   if (selectedSymbol) {
  //     selectedImages.forEach(async (imageId) => {
  //       const selectedImage = selectedSymbol.uploadSymbol.find(
  //         (upload: any) => upload._id === imageId
  //       );

  //       if (selectedImage) {
  //         try {
  //           const encodedUrl = encodeURIComponent(selectedImage.url);
  //           const response = await fetch(encodedUrl);
  //           const blob = await response.blob();

  //           const downloadUrl = URL.createObjectURL(blob);

  //           const downloadLink = document.createElement('a');
  //           downloadLink.href = downloadUrl;
  //           downloadLink.setAttribute('download', 'image.png');
  //           document.body.appendChild(downloadLink);
  //           downloadLink.click();

  //           URL.revokeObjectURL(downloadUrl);
  //         } catch (error) {
  //           console.error('Error downloading image:', error);
  //         }
  //       }
  //     });
  //   }
  // };

  return (
    <ViewJobContainerStyled>
      <div
        style={{
          position: 'sticky',
          top: '60px',
          zIndex: '999',
          paddingTop: '5px',
          background: '#fff',
        }}
      >
        <NavigateBack />
      </div>
      <div className="contents">
        <Typography variant="normal" size={16}>
          Escape plan offers a diverse selection of downloadable shapes for your
          use.
        </Typography>
        <Divider />
        <VerticalSpaceStyled>
          <Typography className="title">Uploaded Symbols :</Typography>
          {symbolsData.map((symbol) => (
            <div key={symbol._id}>
              <Typography
                variant="normal"
                className="section-title"
                fontColor="secondary"
                strong
              >
                {symbol.symbolName}
              </Typography>
              <InfoRowStyled $direction="column">
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    gap: '20px',
                    flexWrap: 'wrap',
                  }}
                >
                  {symbol.uploadSymbol?.map((upload: any) => (
                    <div
                      key={upload._id}
                      style={{
                        position: 'relative',
                        border: (selectedImagesMap[symbol._id] || []).includes(
                          upload._id,
                        )
                          ? `2px solid ${theme.colors.secondary}`
                          : `2px solid ${theme.colors.transparent}`,
                      }}
                    >
                      <Checkbox
                        style={{
                          position: 'absolute',
                          top: '5px',
                          right: '5px',
                          zIndex: 1,
                        }}
                        checked={(selectedImagesMap[symbol._id] || []).includes(
                          upload._id,
                        )}
                        onChange={() =>
                          handleCheckboxChange(symbol._id, upload._id)
                        }
                      />
                      <img
                        src={upload.url}
                        alt={`Symbol ${upload._id}`}
                        style={{ height: '100px', width: '100px' }}
                      />
                    </div>
                  ))}
                </div>
              </InfoRowStyled>
              <Button
                variant="secondary"
                onClick={() => handleDownload(symbol._id)}
                disabled={(selectedImagesMap[symbol._id] || []).length === 0}
              >
                Download
              </Button>
              <Divider style={{ width: '100%' }} />
            </div>
          ))}
          <Divider />
        </VerticalSpaceStyled>
      </div>
    </ViewJobContainerStyled>
  );
};

export default DownloadSymbols;
